// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==========================================================================
   ENTERPRISE TEAM & TECH STACK DIRECTORY STYLING
   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)
   ========================================================================== */

/* ── Hero / Overview Header ────────────────────────────────────────────── */
.team-hero-bar {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    gap: 20px;
    margin-bottom: 24px;
    flex-wrap: wrap;
}

.team-hero-left {
    flex: 1 1;
    min-width: 280px;
}

.team-badge-tag {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #eef2ff;
    color: #4f46e5;
    border: 1px solid #c7d2fe;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 8px;
}

.team-hero-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    margin: 0 0 6px 0;
    letter-spacing: -0.5px;
}

.team-hero-subtitle {
    font-size: 13px;
    color: #64748b;
    margin: 0 0 12px 0;
    max-width: 620px;
    line-height: 1.5;
}

.team-meta-chips {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}

.team-meta-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 4px 10px;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 600;
    color: #475569;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
}

.team-meta-chip i {
    font-size: 12px;
    color: #6366f1;
}

.team-tech-chip {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #334155;
}

.team-tech-chip i {
    color: #4f46e5;
}

/* ── Hero Actions ──────────────────────────────────────────────────────── */
.team-hero-actions {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

.btn-team-action {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    background: #ffffff;
    color: #334155;
    cursor: pointer;
    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.btn-team-action:hover {
    background: #f8fafc;
    border-color: #cbd5e1;
    color: #0f172a;
    transform: translateY(-1px);
}

/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */
.team-kpi-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));
    gap: 16px;
    margin-bottom: 24px;
}

.team-kpi-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 18px 20px;
    display: flex;
    flex-direction: column;
    position: relative;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    transition: all 0.25s ease;
}

.team-kpi-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.team-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.team-kpi-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #64748b;
}

.team-kpi-icon {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.team-icon-indigo  { background: #eef2ff; color: #4f46e5; }
.team-icon-sky     { background: #f0f9ff; color: #0284c7; }
.team-icon-emerald { background: #ecfdf5; color: #10b981; }
.team-icon-purple  { background: #f5f3ff; color: #7c3aed; }

.team-kpi-main {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
}

.team-kpi-val {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 24px;
    font-weight: 800;
    color: #0f172a;
    line-height: 1.1;
}

.team-kpi-tag {
    font-size: 11px;
    font-weight: 700;
    padding: 2px 7px;
    border-radius: 6px;
}

.tag-indigo  { background: #eef2ff; color: #3730a3; }
.tag-sky     { background: #f0f9ff; color: #075985; }
.tag-emerald { background: #ecfdf5; color: #065f46; }
.tag-purple  { background: #f5f3ff; color: #5b21b6; }

.team-kpi-sub {
    font-size: 11.5px;
    color: #64748b;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

/* ── Filter Toolbar ────────────────────────────────────────────────────── */
.team-toolbar-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 16px 20px;
    margin-bottom: 24px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 14px;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
}

.team-toolbar-left {
    display: flex;
    align-items: center;
    gap: 10px;
}

.team-toolbar-title {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin: 0;
}

.team-count-badge {
    background: #eef2ff;
    color: #4f46e5;
    font-size: 11px;
    font-weight: 700;
    padding: 2px 8px;
    border-radius: 9999px;
}

.team-toolbar-controls {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
}

/* Filter Tabs */
.team-filter-tabs {
    display: flex;
    background: #f1f5f9;
    padding: 3px;
    border-radius: 8px;
    gap: 2px;
}

.team-filter-btn {
    background: transparent;
    border: none;
    padding: 5px 10px;
    border-radius: 6px;
    font-size: 11.5px;
    font-weight: 600;
    color: #64748b;
    cursor: pointer;
    transition: all 0.15s ease;
    display: flex;
    align-items: center;
    gap: 5px;
}

.team-filter-btn:hover {
    color: #0f172a;
}

.team-filter-btn.active {
    background: #ffffff;
    color: #4f46e5;
    font-weight: 700;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.team-filter-count {
    font-size: 10px;
    padding: 1px 5px;
    border-radius: 9999px;
    background: #e2e8f0;
    color: #475569;
}

.team-filter-btn.active .team-filter-count {
    background: #eef2ff;
    color: #4f46e5;
}

/* Search Box */
.team-search-box {
    position: relative;
    width: 240px;
}

.team-search-icon {
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%);
    font-size: 12px;
    color: #94a3b8;
    pointer-events: none;
}

.team-search-input {
    width: 100%;
    height: 34px;
    border-radius: 8px;
    border: 1px solid #e2e8f0;
    padding-left: 30px;
    padding-right: 28px;
    font-size: 12.5px;
    background: #f8fafc;
    color: #0f172a;
    transition: all 0.2s ease;
}

.team-search-input:focus {
    outline: none;
    background: #ffffff;
    border-color: #6366f1;
    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

.team-search-clear {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    font-size: 12px;
    color: #94a3b8;
    cursor: pointer;
    padding: 0;
}

/* ── Modern Member Cards Grid ──────────────────────────────────────────── */
.team-members-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
    gap: 18px;
    margin-bottom: 30px;
}

.member-profile-card {
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 22px 20px 18px 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);
    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.member-profile-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 12px 28px -4px rgba(15, 23, 42, 0.08);
    border-color: #cbd5e1;
}

.member-avatar-wrap {
    position: relative;
    margin-bottom: 14px;
}

.member-avatar {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 20px;
    font-weight: 800;
    color: #ffffff;
    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.25);
}

.member-status-dot {
    position: absolute;
    bottom: 2px;
    right: 2px;
    width: 13px;
    height: 13px;
    border-radius: 50%;
    background: #10b981;
    border: 2.5px solid #ffffff;
}

.member-name {
    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);
    font-size: 15px;
    font-weight: 700;
    color: #0f172a;
    margin: 0 0 6px 0;
    line-height: 1.3;
}

.member-role-badge {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 3px 10px;
    border-radius: 9999px;
    font-size: 11px;
    font-weight: 700;
    margin-bottom: 16px;
    white-space: nowrap;
}

.role-badge-mgmt {
    background: #f5f3ff;
    color: #6d28d9;
    border: 1px solid #ddd6fe;
}

.role-badge-fe {
    background: #eef2ff;
    color: #4338ca;
    border: 1px solid #c7d2fe;
}

.role-badge-be {
    background: #f0f9ff;
    color: #0369a1;
    border: 1px solid #bae6fd;
}

.role-badge-qa {
    background: #ecfdf5;
    color: #047857;
    border: 1px solid #a7f3d0;
}

.role-badge-mobile {
    background: #fff1f2;
    color: #be123c;
    border: 1px solid #fecdd3;
}

.role-badge-general {
    background: #f8fafc;
    color: #475569;
    border: 1px solid #e2e8f0;
}

.member-footer-strip {
    width: 100%;
    padding-top: 14px;
    border-top: 1px solid #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
}

.member-email-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 12px;
    font-weight: 500;
    text-decoration: none;
    transition: color 0.15s ease;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.member-email-link:hover {
    color: #4f46e5;
    text-decoration: underline;
}

.member-email-link i {
    color: #6366f1;
    font-size: 13px;
    flex-shrink: 0;
}

/* ── Empty State ───────────────────────────────────────────────────────── */
.team-empty-state {
    padding: 60px 20px;
    text-align: center;
    color: #64748b;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
}

.team-empty-icon-wrap {
    width: 64px;
    height: 64px;
    border-radius: 16px;
    background: #f1f5f9;
    color: #94a3b8;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 28px;
    margin: 0 auto 16px auto;
}

.team-empty-title {
    font-size: 16px;
    font-weight: 700;
    color: #1e293b;
    margin-bottom: 6px;
}

.team-empty-desc {
    font-size: 13px;
    color: #94a3b8;
    max-width: 420px;
    margin: 0 auto 20px auto;
    line-height: 1.5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Team.css"],"names":[],"mappings":"AAAA;;;+EAG+E;;AAE/E,6EAA6E;AAC7E;IACI,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,cAAc;IACd,2BAA2B;AAC/B;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,iDAAiD;IACjD,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;AACpD,eAAe,mBAAmB,EAAE,cAAc,EAAE;;AAEpD;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA,6EAA6E;AAC7E;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;AACb;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA,eAAe;AACf;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,8CAA8C;AAClD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,eAAe;IACf,UAAU;AACd;;AAEA,6EAA6E;AAC7E;IACI,aAAa;IACb,4DAA4D;IAC5D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,4BAA4B;IAC5B,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;IACjD,mDAAmD;AACvD;;AAEA;IACI,2BAA2B;IAC3B,mDAAmD;IACnD,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,iEAAiE;IACjE,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,6BAA6B;IAC7B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;AAClB;;AAEA,6EAA6E;AAC7E;IACI,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;AACpB","sourcesContent":["/* ==========================================================================\n   ENTERPRISE TEAM & TECH STACK DIRECTORY STYLING\n   Theme: Precision Clean SaaS (Linear / Stripe / Vercel style)\n   ========================================================================== */\n\n/* ── Hero / Overview Header ────────────────────────────────────────────── */\n.team-hero-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 20px;\n    margin-bottom: 24px;\n    flex-wrap: wrap;\n}\n\n.team-hero-left {\n    flex: 1;\n    min-width: 280px;\n}\n\n.team-badge-tag {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #eef2ff;\n    color: #4f46e5;\n    border: 1px solid #c7d2fe;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n    margin-bottom: 8px;\n}\n\n.team-hero-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    letter-spacing: -0.5px;\n}\n\n.team-hero-subtitle {\n    font-size: 13px;\n    color: #64748b;\n    margin: 0 0 12px 0;\n    max-width: 620px;\n    line-height: 1.5;\n}\n\n.team-meta-chips {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex-wrap: wrap;\n}\n\n.team-meta-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px 10px;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 600;\n    color: #475569;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);\n}\n\n.team-meta-chip i {\n    font-size: 12px;\n    color: #6366f1;\n}\n\n.team-tech-chip {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #334155;\n}\n\n.team-tech-chip i {\n    color: #4f46e5;\n}\n\n/* ── Hero Actions ──────────────────────────────────────────────────────── */\n.team-hero-actions {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.btn-team-action {\n    display: inline-flex;\n    align-items: center;\n    gap: 8px;\n    padding: 8px 16px;\n    font-size: 13px;\n    font-weight: 600;\n    border-radius: 10px;\n    border: 1px solid #e2e8f0;\n    background: #ffffff;\n    color: #334155;\n    cursor: pointer;\n    transition: all 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.btn-team-action:hover {\n    background: #f8fafc;\n    border-color: #cbd5e1;\n    color: #0f172a;\n    transform: translateY(-1px);\n}\n\n/* ── Executive KPI Cards Grid ──────────────────────────────────────────── */\n.team-kpi-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(210px, 1fr));\n    gap: 16px;\n    margin-bottom: 24px;\n}\n\n.team-kpi-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 18px 20px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    transition: all 0.25s ease;\n}\n\n.team-kpi-card:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 10px 24px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.team-kpi-top {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.team-kpi-label {\n    font-size: 11px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.6px;\n    color: #64748b;\n}\n\n.team-kpi-icon {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.team-icon-indigo  { background: #eef2ff; color: #4f46e5; }\n.team-icon-sky     { background: #f0f9ff; color: #0284c7; }\n.team-icon-emerald { background: #ecfdf5; color: #10b981; }\n.team-icon-purple  { background: #f5f3ff; color: #7c3aed; }\n\n.team-kpi-main {\n    display: flex;\n    align-items: baseline;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.team-kpi-val {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 24px;\n    font-weight: 800;\n    color: #0f172a;\n    line-height: 1.1;\n}\n\n.team-kpi-tag {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 7px;\n    border-radius: 6px;\n}\n\n.tag-indigo  { background: #eef2ff; color: #3730a3; }\n.tag-sky     { background: #f0f9ff; color: #075985; }\n.tag-emerald { background: #ecfdf5; color: #065f46; }\n.tag-purple  { background: #f5f3ff; color: #5b21b6; }\n\n.team-kpi-sub {\n    font-size: 11.5px;\n    color: #64748b;\n    font-weight: 500;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n/* ── Filter Toolbar ────────────────────────────────────────────────────── */\n.team-toolbar-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 16px 20px;\n    margin-bottom: 24px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 14px;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n}\n\n.team-toolbar-left {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.team-toolbar-title {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0;\n}\n\n.team-count-badge {\n    background: #eef2ff;\n    color: #4f46e5;\n    font-size: 11px;\n    font-weight: 700;\n    padding: 2px 8px;\n    border-radius: 9999px;\n}\n\n.team-toolbar-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* Filter Tabs */\n.team-filter-tabs {\n    display: flex;\n    background: #f1f5f9;\n    padding: 3px;\n    border-radius: 8px;\n    gap: 2px;\n}\n\n.team-filter-btn {\n    background: transparent;\n    border: none;\n    padding: 5px 10px;\n    border-radius: 6px;\n    font-size: 11.5px;\n    font-weight: 600;\n    color: #64748b;\n    cursor: pointer;\n    transition: all 0.15s ease;\n    display: flex;\n    align-items: center;\n    gap: 5px;\n}\n\n.team-filter-btn:hover {\n    color: #0f172a;\n}\n\n.team-filter-btn.active {\n    background: #ffffff;\n    color: #4f46e5;\n    font-weight: 700;\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n}\n\n.team-filter-count {\n    font-size: 10px;\n    padding: 1px 5px;\n    border-radius: 9999px;\n    background: #e2e8f0;\n    color: #475569;\n}\n\n.team-filter-btn.active .team-filter-count {\n    background: #eef2ff;\n    color: #4f46e5;\n}\n\n/* Search Box */\n.team-search-box {\n    position: relative;\n    width: 240px;\n}\n\n.team-search-icon {\n    position: absolute;\n    left: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 12px;\n    color: #94a3b8;\n    pointer-events: none;\n}\n\n.team-search-input {\n    width: 100%;\n    height: 34px;\n    border-radius: 8px;\n    border: 1px solid #e2e8f0;\n    padding-left: 30px;\n    padding-right: 28px;\n    font-size: 12.5px;\n    background: #f8fafc;\n    color: #0f172a;\n    transition: all 0.2s ease;\n}\n\n.team-search-input:focus {\n    outline: none;\n    background: #ffffff;\n    border-color: #6366f1;\n    box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n.team-search-clear {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    font-size: 12px;\n    color: #94a3b8;\n    cursor: pointer;\n    padding: 0;\n}\n\n/* ── Modern Member Cards Grid ──────────────────────────────────────────── */\n.team-members-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));\n    gap: 18px;\n    margin-bottom: 30px;\n}\n\n.member-profile-card {\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n    padding: 22px 20px 18px 20px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    text-align: center;\n    position: relative;\n    box-shadow: 0 2px 8px -2px rgba(15, 23, 42, 0.04);\n    transition: all 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.member-profile-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 12px 28px -4px rgba(15, 23, 42, 0.08);\n    border-color: #cbd5e1;\n}\n\n.member-avatar-wrap {\n    position: relative;\n    margin-bottom: 14px;\n}\n\n.member-avatar {\n    width: 64px;\n    height: 64px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 20px;\n    font-weight: 800;\n    color: #ffffff;\n    box-shadow: 0 4px 14px rgba(99, 102, 241, 0.25);\n}\n\n.member-status-dot {\n    position: absolute;\n    bottom: 2px;\n    right: 2px;\n    width: 13px;\n    height: 13px;\n    border-radius: 50%;\n    background: #10b981;\n    border: 2.5px solid #ffffff;\n}\n\n.member-name {\n    font-family: var(--font-heading, 'Plus Jakarta Sans', sans-serif);\n    font-size: 15px;\n    font-weight: 700;\n    color: #0f172a;\n    margin: 0 0 6px 0;\n    line-height: 1.3;\n}\n\n.member-role-badge {\n    display: inline-flex;\n    align-items: center;\n    gap: 5px;\n    padding: 3px 10px;\n    border-radius: 9999px;\n    font-size: 11px;\n    font-weight: 700;\n    margin-bottom: 16px;\n    white-space: nowrap;\n}\n\n.role-badge-mgmt {\n    background: #f5f3ff;\n    color: #6d28d9;\n    border: 1px solid #ddd6fe;\n}\n\n.role-badge-fe {\n    background: #eef2ff;\n    color: #4338ca;\n    border: 1px solid #c7d2fe;\n}\n\n.role-badge-be {\n    background: #f0f9ff;\n    color: #0369a1;\n    border: 1px solid #bae6fd;\n}\n\n.role-badge-qa {\n    background: #ecfdf5;\n    color: #047857;\n    border: 1px solid #a7f3d0;\n}\n\n.role-badge-mobile {\n    background: #fff1f2;\n    color: #be123c;\n    border: 1px solid #fecdd3;\n}\n\n.role-badge-general {\n    background: #f8fafc;\n    color: #475569;\n    border: 1px solid #e2e8f0;\n}\n\n.member-footer-strip {\n    width: 100%;\n    padding-top: 14px;\n    border-top: 1px solid #f1f5f9;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.member-email-link {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    color: #64748b;\n    font-size: 12px;\n    font-weight: 500;\n    text-decoration: none;\n    transition: color 0.15s ease;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.member-email-link:hover {\n    color: #4f46e5;\n    text-decoration: underline;\n}\n\n.member-email-link i {\n    color: #6366f1;\n    font-size: 13px;\n    flex-shrink: 0;\n}\n\n/* ── Empty State ───────────────────────────────────────────────────────── */\n.team-empty-state {\n    padding: 60px 20px;\n    text-align: center;\n    color: #64748b;\n    background: #ffffff;\n    border: 1px solid #e2e8f0;\n    border-radius: 16px;\n}\n\n.team-empty-icon-wrap {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n    background: #f1f5f9;\n    color: #94a3b8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 28px;\n    margin: 0 auto 16px auto;\n}\n\n.team-empty-title {\n    font-size: 16px;\n    font-weight: 700;\n    color: #1e293b;\n    margin-bottom: 6px;\n}\n\n.team-empty-desc {\n    font-size: 13px;\n    color: #94a3b8;\n    max-width: 420px;\n    margin: 0 auto 20px auto;\n    line-height: 1.5;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
